<template>
  <div class="">
    <div class="columns is-vcentered is-gapless is-border-bottom">
      <div class="column is-narrow is-border-right"
        v-if="backButton" >
        <a class="page-header-btn is-small is-square" @click="goBack">
          <span class="icon">
            <i class="far fa-arrow-to-left"></i>
          </span>
        </a>
      </div>
      <div class="column"
        :class="{'is-padding-left' : backButton, 'is-narrow': searchTotal !== false}">
        <slot name="left">
          <h1 class="title is-3 is-paddingless">
            <span>
              <span v-if="label && total" class="">
                <span v-if="total">{{total}}</span>&nbsp;
                <span v-if="label" class="is-uppercase">{{labelPlurialize}}</span>&nbsp;
              </span>
              <span v-if="helper" v-helper.bottomLeft="helper">
                <i class="fal fa-info-circle fa-xs"></i>
              </span>
              <slot name="left-title"></slot>
            </span>
            <span v-if="bigTotal" class="has-text-weight-medium has-text-grey is-uppercase">au {{today}}</span>
            <span class="has-text-weight-medium has-text-grey">
              <slot name="left-content"></slot>
            </span>
          </h1>
        </slot>
      </div>

      <slot name="nbr-resultat" v-if="searchTotal !== false">
        <div slot="nbr-resultat" class="column is-narrow has-bg-primary columns is-vcentered is-gapless is-self-stretched is-margin-left">
          <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{searchTotal}} {{labelPlurialize}}</div>
        </div>
      </slot>
      <div class="column is-paddingless" v-if="searchTotal !== false"></div>

      <slot name="right">
        <div class="column has-text-right page-header-slotRight" :class="[{'is-narrow columns' : backButton, 'is-size-5' : !backButton}, classOnRightSlot]">
          <a v-for="a in availableActions" :disabled="loading" @click.prevent.stop="a.action"
            :class="a.linkClass" v-if="availableActions && availableActions.length" :key="a.text">
            <span class="icon is-small">
              <i class="fal" :class="a.icon"></i>
            </span>
            <span>{{ a.text }}</span>
          </a>
          <slot name="left-action"></slot>
          <div class="dropdown is-hoverable is-right" v-if="hasDropdown" :class="{'is-border-left' : backButton || calendarMonth}">
            <div class="dropdown-trigger" :class="{'is-flex' : backButton}">

              <!-- Si back btn (nouveau style) -->
              <button aria-haspopup="true" aria-controls="dropdown-menu" class="page-header-btn is-small page-header-btn--separetedIco-right is-small">
                <span>Actions</span>
                <span class="icon is-small is-size-4"><i class="far fa-ellipsis-v"></i></span>
              </button>
              <!-- Si pas de back btn (ancien style) -->
              <!-- <a v-if="!backButton" class="button is-white">
                <span class="is-padding-left-small is-padding-right-small" aria-haspopup="true" aria-controls="dropdown-menu">
                  <i class="far fa-ellipsis-v"></i>
                </span>
              </a> -->
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content has-text-left">
                <slot name="dropdown-content"></slot>
              </div>
            </div>
          </div>
          <slot name="right-content"></slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'Sticky',
    props: {
      actions: {
        type: Array,
        required: false,
        default () {
          return []
        }
      },
      bigTotal: {
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: false
      },
      total: {
        required: false
      },
      helper: {
        required: false
      },
      backButton: {
        type: Boolean,
        default: true
      },
      calendarMonth: {
        type: Boolean,
        default: false
      },
      searchTotal: {
        required: false,
        default: false
      },
      forceGoBack: Object,
      classOnRightSlot: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapGetters(['currentUserProfil']),
      today () {
        return moment().format('DD/MM/YYYY')
      },
      hasDropdown () {
        // console.log('slots: ', this.$slots['dropdown-content'])
        return this.$slots['dropdown-content'] && this.$slots['dropdown-content'].length
      },
      hasHistory () {
        return window.history.length > 1
      },
      availableActions () {
        let availableActions = []
        this.actions.forEach(a => {
          let display = true
          if (a.display && typeof a.display === 'function') {
            display = a.display(this.data)
          } else if (a.display === false) {
            display = a.display
          }
          if (display && (!a.needProfile || a.needProfile.includes(this.currentUserProfil))) {
            availableActions.push(a)
          }
        })
        return availableActions
      },
      labelPlurialize () {
        let s = this.label
        if (this.total > 1) {
          if (s[s.length - 1] === 'u') {
            s += 'x'
          } else if (s[s.length - 1] !== 'x' && s[s.length - 1] !== 's') {
            s += 's'
          }
        }
        return s
      }
    },
    methods: {
      goBack () {
        if (this.forceGoBack) {
          return this.$router.push(this.forceGoBack)
        } else {
          return this.$router.goBack(this.$route)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/Sticky.vue